<script>
  import Images from "./Images/Images.svelte";

/* 
  const images = [...Array(10).keys()].map(i => ({
    src: `./images/${i + 1}.jpeg`
  })); 
*/ 
  
// console.log(images_orig);


var images = [];

    var xhr = new XMLHttpRequest(); // New request object
    xhr.onload = function() {
        // This is where you handle what to do with the response.
        // The actual data is found on this.responseText
     //   console.log(this.responseText);
       // images = JSON.parse(this.responseText);

        images = JSON.parse(this.responseText);
        
    //    console.log(images);
    //    console.log(images.length);
     
    };
    
    xhr.open("get", "./dir.php", true);
    //                               ^ Don't block the rest of the execution.
    //                                 Don't wait until the request finishes to
    //                                 continue.
    xhr.send();



var pwd= "";
var xhra = new XMLHttpRequest(); // New request object
    xhra.onload = function() {
        pwd = JSON.parse(this.responseText);
    };
    
    xhra.open("get", "./here.php", true);
    xhra.send();

</script>

<style>
  main {
    height: 75vh;
  }
  h1 {
    margin-left: 50px;
    display: inline;
  }
</style>

<svelte:head>Zdjęcia</svelte:head>

<main>
<a href=".."><img src="../build/back.svg" alt="wstecz"></a>
<h1>{pwd}</h1>

  <Images {images} gutter={3} numCols={5} />
</main>
